import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { useInitiateConfigQuery } from '../../../../queries/useInitiateConfigQuery';
import useHomeStore from '../../../../store/homeStore';
import { useNotificationStore } from '../../../../store/notificationStore';
import { ENotificationTypes } from '../../../features/Notifications/INotification';
import styles from './MaintenanceBanner.module.scss';

export default function MaintenanceBanner() {
  const { config } = useInitiateConfigQuery();
  const showMaintenanceBanner = useHomeStore(
    (state) => state.showMaintenanceBanner
  );
  const setShowMaintenanceBanner = useHomeStore(
    (state) => state.setShowMaintenanceBanner
  );
  const notifications = useNotificationStore((state) => state.notifications);
  const setNotifications = useNotificationStore(
    (state) => state.setNotifications
  );

  const [maintenanceBannerText, setMaintenanceBannerText] =
    useState<string>('');

  const updateNotifications = (json: {
    maintenanceBannerText: string;
  }): void => {
    const notification = notifications;
    const notificationExists = notification.some(
      (x) => x.id === 'maintenance-notification-43c3-91ba-02698dcc98c9'
    );

    if (!notificationExists) {
      // Sanitize the HTML content for notification
      const sanitizedMessage = DOMPurify.sanitize(json.maintenanceBannerText);
      notification.push({
        id: 'maintenance-notification-43c3-91ba-02698dcc98c9',
        title: 'Maintenance',
        time: new Date().getTime(),
        message: sanitizedMessage,
        type: ENotificationTypes.MAINTENANCE,
      });
      setNotifications(notification);
    }
  };

  const dismissBanner = (): void => {
    localStorage.setItem('showMaintenanceBanner', 'false');
    setShowMaintenanceBanner('false');
  };

  useEffect(() => {
    if (config.data) {
      const json = config.data;
      const currentDate = new Date();
      const showBannerUntilDate = new Date(json.showMaintenanceBannerUntil);

      if (
        json.showMaintenanceBanner === 'true' &&
        currentDate < showBannerUntilDate
      ) {
        // Sanitize the HTML content
        const sanitizedText = DOMPurify.sanitize(json.maintenanceBannerText);
        setMaintenanceBannerText(sanitizedText);
        setShowMaintenanceBanner('true');
        updateNotifications(json);
      } else {
        setShowMaintenanceBanner('false');
      }
    }
  }, [config.data]);

  return showMaintenanceBanner === 'true' ? (
    <div className={styles.root}>
      <CloseOutlined className={styles.closeIcon} onClick={dismissBanner} />
      <div className={styles.content}>
        <div className={styles.warningIcon}>
          <WarningOutlined />
        </div>
        <div
          className={styles.message}
          dangerouslySetInnerHTML={{ __html: maintenanceBannerText }}
        />
      </div>
      <div className={styles.closeBtnRow}>
        <Button onClick={dismissBanner}>Close</Button>
      </div>
    </div>
  ) : null;
}
